<div class="row m-3">
  <div class="col-12 border border-primary rounded">
    <div class="row mt-3">
      <div class="col-12 input-group">
        <button class="btn btn-primary ml-3" *ngIf="role.dpa_button_newcase" (click)="createCase()">
          <span class="fa fa-file"></span>
          สร้างรายงานการติดต่อ
        </button>
        <button class="btn btn-primary ml-3" *ngIf="role.dpa_button_reaasigncase" (click)="forward()">
          <span class="fa fa-paper-plane"></span>
          ส่งต่อรายงานการติดต่อ
        </button>
        <button class="btn btn-primary ml-3" *ngIf="role.dpa_button_delete" (click)="delete()">
          <span class="fa fa-trash"></span>
          ลบ
        </button>
        <!-- <input type="search" class="form-control col-3 ml-auto" placeholder="Search"> -->
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="card card-default ">

          <div class="card-header">
            <div class="row">
              <div class="col-10 my-auto">
                <h3 class="card-title font-cust-blue">ประวัติรายงานการติดต่อ</h3>
              </div>
              <div class="col-2 text-right">
                <button class="btn btn-link" (click)="searchCase()">
                  <span class="fa fa-lg fa-sync-alt"></span>
                </button>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <table #tbC id="tbCase" style="width:100%" class="table table-bordered table-hover result-table">
              <thead>
                <tr>
                  <th class="checkbox-col">
                    <input type="checkbox" [(ngModel)]="isCheckedAll" (change)="onCheckAllChange()">
                  </th>
                  <th>Title</th>
                  <th>Contact</th>
                  <th>Origin Source</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of caseHistoryList; let i = index" id="{{c.ticketnumber}}">
                  <td align="center" class="checkbox-col">
                    <input type="checkbox" class="row-checker" value="{{c.incidentid}}" name="{{c.customerid}}">
                  </td>
                  <td>{{c.dpa_casesubtypedetailidname == null ? c.dpa_casesubtypeidname :
                    c.dpa_casesubtypedetailidname}}</td>
                  <td>{{c.customeridname}}</td>
                  <td>{{c.dpa_casechannelidname}}</td>
                  <td class="status">{{c.dpa_casestatusidname}}</td>
                  <td>{{c.createdon | thaidate: 'shortWithTime'}}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="card card-default ">

          <div class="card-header">
            <div class="row">
              <div class="col-10 my-auto">
                <h3 class="card-title font-cust-blue">ประวัติการคุย Chat bot</h3>
              </div>
              <div class="col-2 text-right">
                <button class="btn btn-link" (click)="searchChatbot()">
                  <span class="fa fa-lg fa-sync-alt"></span>
                </button>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <table #tbB id="tbChatbot" style="width:100%" class="table table-bordered table-hover result-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Contact</th>
                  <th>Channel</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of chatBotLastRow">
                  <td>{{c.dpa_title}}</td>
                  <td>{{contactFullname}}</td>
                  <td>{{c.dpa_platform}}</td>
                  <td>{{c.dpa_conversion_date | thaidate}}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="card card-default ">

          <div class="card-header">
            <div class="row">
              <div class="col-10 my-auto">
                <h3 class="card-title font-cust-blue">ประวัติการส่ง Email</h3>
              </div>
              <div class="col-2 text-right">
                <button class="btn btn-link" (click)="searchEmail()">
                  <span class="fa fa-lg fa-sync-alt"></span>
                </button>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <table #tbE id="tbEmail" style="width:100%" class="table table-bordered table-hover result-table">
              <thead>
                <tr>
                  <th>Email Template</th>
                  <th>Contact</th>
                  <th>Origin Source</th>
                  <th>Status</th>
                  <th>Sent Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let e of emailHistoryList" id="{{e.dpa_activityhistoryid}}">
                  <td>{{e.dpa_templatename || ''}}</td>
                  <td>{{e.contact_firstname + ' ' + (e.contact_lastname || '')}}</td>
                  <td>Email</td>
                  <td>ส่งแล้ว</td>
                  <td>{{e.modifiedon | thaidate: 'short'}}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="card card-default ">

          <div class="card-header">
            <div class="row">
              <div class="col-10 my-auto">
                <h3 class="card-title font-cust-blue">ประวัติการส่ง SMS</h3>
              </div>
              <div class="col-2 text-right">
                <button class="btn btn-link" (click)="searchSMS()">
                  <span class="fa fa-lg fa-sync-alt"></span>
                </button>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <table #tbS id="tbSMS" style="width:100%" class="table table-bordered table-hover result-table">
              <thead>
                <tr>
                  <th>SMS Template</th>
                  <th>Contact</th>
                  <th>Origin Source</th>
                  <th>Status</th>
                  <th>Sent Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let e of smsHistoryList" id="{{e.dpa_activityhistoryid}}">
                  <td>{{e.dpa_templatename}}</td>
                  <td>{{e.contact_firstname + ' ' + e.contact_lastname}}</td>
                  <td>SMS</td>
                  <td>ส่งแล้ว</td>
                  <td>{{e.modifiedon | thaidate: 'short'}}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>



<!-- Modal Forward-->
<div class="modal fade" id="forwardInHistoryModal" tabindex="-1" role="dialog"
  aria-labelledby="forwardInHistoryModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="forwardInHistoryModalLabel">ส่งต่อรายงานการติดต่อ</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label class="required">ทีม</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="forwardTeam" (change)="onForwardTeamChange()">
              <option value="" selected>เลือก</option>
              <option *ngFor="let t of teamList" [value]="t.dpa_callcenterteamid">
                {{t.dpa_name}}
              </option>
            </select>
            <span class="text-danger" *ngIf="submittedForward && forwardTeam == ''">
              กรุณาเลือก ทีม
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="">ผู้ใช้งาน</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="userIdReceive">
              <option value="">เลือก</option>
              <option *ngFor="let a of userList" [value]="a.dpa_customwebuserid">
                {{a.dpa_name}}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="required">หมายเหตุ</label>
          </div>
          <div class="col-7">
            <input type="text" class="form-control" [(ngModel)]="forwardRemark">
            <span class="text-danger" *ngIf="submittedForward && forwardRemark == ''">
              กรุณาระบุ หมายเหตุ
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmForward()">OK</button>
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Delete-->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="deleteModalLabel">ยืนยันลบ</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-3 text-right">
            <label class="required">เหตุผล:</label>
          </div>

          <div class="col-9">
            <textarea class="form-control" rows="3" [(ngModel)]="cancelRemark"></textarea>
            <span class="text-danger" *ngIf="submittedCancel && cancelRemark.trim().length == 0">
              กรุณาระบุเหตุผลในการยกเลิก
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmDelete()">ลบ</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('deleteModal')">ยกเลิก</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal Chatbot history-->
<div class="modal fade" id="chatbotHistoryModal" tabindex="-1" role="dialog" aria-labelledby="chatbotHistoryModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">

      <div class="modal-body">
        <div class="row">
          <div class="col-12 bg-cust-blue text-white pt-2">
            <h6>Chatbot History</h6>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <!-- <div class="row mt-3">
              <div class="col-6"></div>

              <div class="col-3 text-right">
                <label>ประเภทรายงานการติดต่อ</label>
              </div>
              <div class="col-3">
                <select class="form-control" disabled>
                  <option selected>สอบถาม</option>
                </select>
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-3 text-right">
                <label>สถานะรายงานการติดต่อ</label>
              </div>
              <div class="col-3">
                <select class="form-control" disabled>
                  <option selected>In Progress</option>
                </select>
              </div>
              <div class="col-3 text-right">
                <label>แหล่งที่มา</label>
              </div>
              <div class="col-3">
                <select class="form-control" disabled>
                  <option selected>Chatbot</option>
                </select>
              </div>
            </div> -->

            <div class="row mt-3">
              <div class="col-3 text-right">
                <label>ชื่อเรื่อง</label>
              </div>
              <div class="col-9">
                <input type="text" class="form-control" value="{{chatBotLastRow.dpa_title}}" readonly>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-3 text-right">
                <label>User ID</label>
              </div>
              <div class="col-9">
                <input type="text" class="form-control" value="{{chatBotLastRow.dpa_userid}}" readonly>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-3 text-right">
                <label>ผู้ติดต่อ</label>
              </div>
              <div class="col-3">
                <input type="text" class="form-control" value="{{contactFullname}}" readonly>
              </div>

              <div class="col-3 text-right">
                <label>ผ่านช่องทาง</label>
              </div>
              <div class="col-3">
                <input type="text" class="form-control" value="{{chatBotLastRow.dpa_platform}}" readonly>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 table-responsive">
                <table id="table33" style="width:100%" class="table table-bordered table-hover result-table">
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th>Answer</th>
                      <th>Sender</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of chatbotHistoryList">
                      <td>{{item.dpa_sourcetype == 1 ? item.dpa_message : '' }}</td>
                      <td>{{item.dpa_sourcetype == 2 ? item.dpa_message : '' }}</td>
                      <td>{{item.dpa_sourcetype == 1 ? 'Custom Editorial' : 'Agent' }}</td>
                      <td>{{item.dpa_conversion_date | thaidate: 'shortWithTime' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <div class="row mt-3">
              <div class="col-3 text-right">
                <label>วันที่สร้างข้อมูล</label>
              </div>
              <div class="col-3">
                <input type="text" class="form-control" readonly value="19 ต.ค. 2563">
              </div>
              <div class="col-3 text-right">
                <label>วันที่แก้ไขข้อมูลล่าสุด</label>
              </div>
              <div class="col-3">
                <input type="text" class="form-control" readonly value="19 ต.ค. 2563">
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-3 text-right">
                <label>ผู้สร้างข้อมูล</label>
              </div>
              <div class="col-3">
                <input type="text" class="form-control" readonly value="Agent 2">
              </div>
            </div> -->

          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-danger col-md-2" data-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal Email History-->
<div class="modal fade" id="emailHistoryModal" tabindex="-1" role="dialog" aria-labelledby="chatbotHistoryModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">

      <div class="modal-body">
        <div class="row">
          <div class="col-12 bg-cust-blue text-white pt-2">
            <h6>Email History</h6>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>Email ที่ส่ง</label>
              </div>
              <div class="col-10">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.dpa_emailaddress}}">
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>ชื่อ</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.contact_firstname}}">
              </div>

              <div class="col-2 text-right">
                <label>นามสกุล</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.contact_lastname}}">
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-2 text-right">
                <label>Email Template</label>
              </div>
              <div class="col-10">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.dpa_templatename}}">
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2"></div>
              <div class="col-10">
                <div class="border p-3 overflow-auto" style="background-color: #E9ECEF;"
                  [innerHtml]="emailAndSmsDetail.dpa_description">
                </div>
              </div>

            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>วันที่สร้างข้อมูล</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly
                  value="{{emailAndSmsDetail.createdon | thaidate: 'short'}}">
              </div>
              <div class="col-2 text-right">
                <label>วันที่ Update ข้อมูลล่าสุด</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly
                  value="{{emailAndSmsDetail.modifiedon | thaidate: 'short'}}">
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-2 text-right">
                <label>ผู้สร้างข้อมูล</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.dpa_createdbyname}}">
              </div>
            </div>

          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-danger col-md-2" data-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal sms history-->
<div class="modal fade" id="smsHistoryModal" tabindex="-1" role="dialog" aria-labelledby="chatbotHistoryModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">

      <div class="modal-body">
        <div class="row">
          <div class="col-12 bg-cust-blue text-white pt-2">
            <h6>SMS History</h6>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>เบอร์ที่ส่ง</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.dpa_phoneno}}">
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-2 text-right">
                <label>ชื่อ</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.contact_firstname}}">
              </div>

              <div class="col-2 text-right">
                <label>นามสกุล</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.contact_lastname}}">
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-2 text-right">
                <label>SMS Template</label>
              </div>
              <div class="col-10">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.dpa_templatename}}">
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2"></div>
              <div class="col-10">
                <div class="border p-3 overflow-auto" style="background-color: #E9ECEF;"
                  [innerHtml]="emailAndSmsDetail.dpa_description">
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-2 text-right">
                <label>วันที่สร้างข้อมูล</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly
                  value="{{emailAndSmsDetail.createdon | thaidate: 'short'}}">
              </div>
              <div class="col-2 text-right">
                <label>วันที่ Update ข้อมูลล่าสุด</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly
                  value="{{emailAndSmsDetail.modifiedon | thaidate: 'short'}}">
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-2 text-right">
                <label>ผู้สร้างข้อมูล</label>
              </div>
              <div class="col-4">
                <input type="text" class="form-control" readonly value="{{emailAndSmsDetail.dpa_createdbyname}}">
              </div>
            </div>

          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-danger col-md-2" data-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal new contact-->
<!-- <div class="modal fade" id="newCaseModal" tabindex="-1" role="dialog" aria-labelledby="newCaseModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">

      <div class="modal-body">
        <div class="row">
          <div class="col-12 p-0">
            <app-new-case></app-new-case>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info m-2" (click)="save()" *ngIf="!viewCase">
              <span class="fa fa-check"></span>
              บันทึก
            </button>
            <button type="button" class="btn btn-info m-2" (click)="save(true)" *ngIf="!viewCase">
              <span class="fa fa-check"></span>
              บันทึกและปิด
            </button>
            <button type="button" class="btn btn-info m-2" *ngIf="role.dpa_button_reaasigncase || !viewCase" (click)="forward()">
              <span class="fa fa-paper-plane"></span>
              ส่งต่อ
            </button>
            <button type="button" class="btn btn-info m-2"  data-dismiss="modal">
              <span class="fa fa-times"></span>
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->


// WEBPACK FOOTER //
// ./src/app/contact-history/contact-history.component.html